export class WarehouseConstants {
  static WAREHOUSE_TYPE_WAREHOUSE = 0;
  static WAREHOUSE_TYPE_USER = 1;
  static WAREHOUSE_TYPE_GUEST = 2;
}
